export default {
  name: "Footer",
  computed: {
    /**
     * Work out the date range for the footer copyright notice.
     * @returns {string}
     */
    copyrightDateRange: function () {
      const yearNow = new Date().getFullYear();

      if (!this.$store.state.config.copyright_start || yearNow == this.$store.state.config.copyright_start) {
        return yearNow;
      }

      return `${this.$store.state.config.copyright_start} - ${yearNow}`;
    },
  },
};
